import React, { useState } from "react";
import {Grid } from '@material-ui/core';
import { Box, Card, CardContent, FormControl, InputLabel, Alert, AlertTitle, Button, Select, MenuItem } from '@mui/material';
import MainCard from '../components/MainCard';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';


const FactoryImageSelectionPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [project, setProject] = useState("");
  function handleProject(e) {
        setProject(e.target.value);
  }

  const [image, setImage] = useState("");
  function handleImage(e) {
        setImage(e.target.value);
  }

  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const styleField = {
    width: '100%',
  };

  const columns = [{ field: 'file_name', headerName: 'Image name', flex: 1}];
  const projectOption = [
  {label: 'Topaz', value: 'topaz'},
  {label: 'Qbert', value: 'qbert'},
  {label: 'Ruby', value: 'ruby'},
  {label: 'Sapphire', value: 'sapphire'},
  {label: 'Obsidian', value: 'obsidian'},
  {label: 'Amber', value: 'amber'},
  {label: 'Redstone', value: 'redstone'}
  ]

  const imageTypeOption = [
  {label: 'signed', value: 'signed'},
  {label: 'user_dbgblk', value: 'user_dbgblk'},
  {label: 'user', value: 'user'},
  {label: 'userdebug_dbgblk', value: 'userdebug_dbgblk'},
  {label: 'userdebug', value: 'userdebug'}]
  
  const handleQueryData = () => {
    if (project === "" || image === "" ){
      alert("Please select prefix and date!");
    }else{
      setRows([]);
      var input_data = JSON.stringify({ project: project, image_type: image })
      axios.post("/peloton/v1/automation/factory-image-list",input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          if (response.data.images !== null && response.data.images.length > 0){
            setRows(response.data.images);
            if (response.data.selected !== null && response.data.selected.length > 0){
              setSelectedRows(response.data.selected);
            }
            setshowAlert(false);
            setshowTable(true);
          }else{
            setshowAlert(true);
          }
        }else{
          alert(response.data.message);
        }
      }).catch(err => {
        if (err.message === 'timeout of 3000ms exceeded'){

        }else{
          if (!err.response){
            alert(err)
          }else{
            if (err.response.status === 401){
              navigate("/");
            }else{
              alert(err.response.data.message);
            }
          }
        }
      })
    }
  };

  const handleUpdateData = () => {
    if (project === "" || image === "" ){
      alert("Please select prefix and date!");
    }else{
      var input_data = JSON.stringify({ project: project, image_type: image, selected: selectedRows })
      axios.put("/peloton/v1/automation/factory-image-list",input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          alert('Update success!');
        }else{
          alert(response.data.message);
        }
      }).catch(err => {
          if (!err.response){
            alert(err)
          }else{
            if (err.response.status === 401){
              navigate("/");
            }else{
              alert(err.response.data.message);
            }
          }
      })
    }
  };

  return (
    <MainCard title="OOBE image selection">
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
      OOBE Test
      </Box>
      <Grid container direction="row" justifyContent="space-around" alignItems="center" >
        <Grid item xs={1}>
        </Grid>
        <Grid item xs={2}>
          <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Project</InputLabel>
            <Select
              id="project"
              fullWidth
              value={project}
              onChange={handleProject}
              variant="filled"
            >
              {projectOption.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
            </Grid>
            <Grid item xs={3}>
            <FormControl style={styleField} >
            <InputLabel id="demo-simple-select-standard-label">Select Image Type</InputLabel>
              <Select
                id="image-type"
                fullWidth
                value={image}
                onChange={handleImage}
                variant="filled"
              >
                {imageTypeOption.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        <Grid item xs={1}>
        </Grid>
        <Grid item xs={1}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      <MainCard >
      { showTable && (<Box sx={{ mb: 2 }}>
      <Button style={styleButton} onClick={handleUpdateData}>Set</Button>
      </Box>)}
      { showTable && (<DataGrid
        sx={{ bgcolor: "white" }}
        rows={rows}
        columns={columns}
        getRowId={(row) => row.file_name}
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={setSelectedRows}
        checkboxSelection
        disableColumnMenu
        disableSelectionOnClick
      />)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        No image in the condition!
      </Alert></Card>)}
      </MainCard>
    </MainCard>)
};

export default FactoryImageSelectionPage;
